import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/atencao-basica`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioAtendimentoOdontologico(queryParms) {
            return repository.get(`${baseUrl}/relatorio-atendimento-odontologico?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioCadastroConsistente(params)
        {
            return repository.get(`${baseUrl}/relatorio-cadastro-consistente?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCadastroConsistentePaciente(params)
        {
            return repository.get(`${baseUrl}/relatorio-cadastro-consistente/paciente?${urlUtil.serialize(params)}`, headers)
        },
        relatorioEstatisticoAtendimento(params)
        {
            return repository.get(`${baseUrl}/relatorio-estatistico-atendimento?${urlUtil.serialize(params)}`, headers)
        },
        relatorioInconsistencia(params)
        {
            return repository.get(`${baseUrl}/relatorio-inconsistencia?${urlUtil.serialize(params)}`, headers)
        },
        relatorioEstatisticoPacienteCadastrado(params)
        {
            return repository.post(`${baseUrl}/relatorio-estatistico-paciente-cadastrado`, params, headers)
        },
        relatorioVisitaDomiciliar(params) {
            return repository.post(`${baseUrl}/relatorio-visita-domiciliar`, params, headers)
        },
        relatorioAcessoCuidadoProgramado(params)
        {
            return repository.get(`${baseUrl}/relatorio-acesso-cuidado-programado?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoPessoaComDiabete(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-pessoa-com-diabete?${urlUtil.serialize(params)}`, headers)
        },
        relatorioAtendimentoDomiciliar(params)
        {
            return repository.get(`${baseUrl}/relatorio-atendimento-domiciliar?${urlUtil.serialize(params)}`, headers)
        },
        relatorioIndicadorSad(params)
        {
            return repository.get(`${baseUrl}/relatorio-indicador-sad?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoPessoaHipertensao(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-pessoa-hipertensao?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoGestacaoPuerperio(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-gestacao-puerperio?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoDesenvolvimentoInfantil(params)
        {
            return repository.post(`${baseUrl}/relatorio-cuidado-desenvolvimento-infantil`, params, headers)
        },
        relatorioCuidadoMulherPrevencaoCancer(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-mulher-prevencao-cancer?${urlUtil.serialize(params)}`, headers)
        },
        relatorioCuidadoPessoaIdosa(params)
        {
            return repository.get(`${baseUrl}/relatorio-cuidado-pessoa-idosa?${urlUtil.serialize(params)}`, headers)
        },
    }
}
